import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["draggable", "onDragstart", "onDragenter"]

import SlideView from "@/views/share/SlideView.vue";
import {computed, h, onMounted, onUnmounted, reactive} from "vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/model/editor";
import {SettingOutlined} from "@ant-design/icons-vue";
import ModuleItemView from "@/views/activity/components/ModuleItemView.vue";
import emit from "@/lib/emit";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditorSide',
  setup(__props) {


const editor = useRoute().meta.editor as AEditor;
const info = reactive({open: false, dragPosition: 0})

const menu = computed(() => {
  return editor.active.menu.items.filter(i => !i.business || i.business.enabled)
})

onMounted(() => {
  emit.on('editor.menu.custom', onMenuShow);
  emit.on('window.resize',windowSizeChange)
  windowSizeChange();
})

onUnmounted(() => {
  emit.off('editor.menu.custom', onMenuShow);
  emit.off('window.resize',windowSizeChange)
})

const windowSizeChange = () => {
  if (window.innerWidth < 1600 && !editor.active.menu.toggle) editor.active.menu.toggle = true;
  else if (window.innerWidth > 1600 && editor.active.menu.toggle) editor.active.menu.toggle = false;
}

const onMenuShow = () => info.open = true

const onDragStart = (ev: DragEvent, i: number) => {
  // console.log('onDragStart',ev, i)
  ev.stopPropagation()
  // ev.target instanceof HTMLInputElement ? ev.target.style.cursor = 'move' : null
  info.dragPosition = i
  setTimeout(() => (ev.target as HTMLImageElement).classList.add('moving'), 0)
}

const onDragEnter = (ev: DragEvent, i: number) => {
  // console.log('onDragEnter', i, this.arr)
  ev.preventDefault()
  if (info.dragPosition != i) {
    const s = editor.active.menu.items[info.dragPosition]
    const t = editor.active.menu.items[i]
    if (t.lock) return
    editor.active.menu.items.splice(i, 1, s)
    editor.active.menu.items.splice(info.dragPosition, 1, t)
    info.dragPosition = i
  }
}

const onDragEnd = (ev: DragEvent) => {
  (ev.target as HTMLImageElement).classList.remove('moving')
}

const onDragOver = (ev: DragEvent) => {
  ev.preventDefault()
  if (ev.dataTransfer) ev.dataTransfer.dropEffect = 'move'
}

return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(SlideView, {
    toggle: _unref(editor).active.menu.toggle,
    "onUpdate:toggle": _cache[2] || (_cache[2] = ($event: any) => ((_unref(editor).active.menu.toggle) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_menu, {
        items: menu.value,
        "inline-collapsed": _unref(editor).active.menu.toggle,
        "selected-keys": _unref(editor).active.menu.selectedKeys,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editor).active.menu.selectedKeys) = $event)),
        mode: "inline"
      }, null, 8, ["items", "inline-collapsed", "selected-keys"]),
      _createVNode(_component_a_divider),
      (_unref(editor).active.menu.items.filter(i => !i.lock).length)
        ? (_openBlock(), _createBlock(_component_a_flex, {
            key: 0,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                icon: h(_unref(SettingOutlined)),
                onClick: onMenuShow
              }, null, 8, ["icon"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_modal, {
        open: info.open,
        "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((info.open) = $event)),
        title: "订制业务",
        footer: null,
        "cancel-button-props": {style:{display: 'none'}}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_flex, {
            wrap: "wrap",
            gap: "middle",
            class: "menu-custom"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editor).active.menu.items, (c, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: c.business!.kind,
                  draggable: !c.lock,
                  onDragstart: ($event: any) => (onDragStart($event,index)),
                  onDragenter: ($event: any) => (onDragEnter($event,index)),
                  onDragend: onDragEnd,
                  onDragover: onDragOver,
                  style: _normalizeStyle({width: '228px', cursor: c.lock ? 'no-drop' : 'move'})
                }, [
                  _createVNode(ModuleItemView, {
                    title: c.label,
                    name: c.business!.kind,
                    description: c.description,
                    must: c.lock,
                    checked: c.business!.enabled,
                    onOnChecked: (_,checked) => c.business!.enabled = checked
                  }, null, 8, ["title", "name", "description", "must", "checked", "onOnChecked"])
                ], 44, _hoisted_1))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["toggle"]))
}
}

})